import { Box, Button, Grid, Modal, Typography, useTheme } from "@mui/material";
import { useDispatch } from "@src/store";
import { removeFolder } from "@src/store/slices/menu";

const DeleteFolderModal = ({
  isVisible,
  onDismiss,
  selectedFolder = undefined,
  isChildFolder = false,
}) => {
  const theme = useTheme();
  const dispatch = useDispatch();

  const onDeleteFolder = () => {
    dispatch(removeFolder(selectedFolder));
  };

  return (
    <Modal
      open={isVisible}
      onClose={() => onDismiss()}
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Box
        sx={{
          position: "absolute",
          width: "50%",
          backgroundColor: "white",
          borderRadius: 3,
          padding: theme.spacing(2),
        }}
      >
        <Grid container spacing={2} direction="row">
          <Grid item xs={12}>
            <Typography variant="h3" component="h2">
              Delete Folder
            </Typography>
          </Grid>

          <Grid item xs={12}>
            <Typography variant="body1" component="p">
              {isChildFolder
                ? "Are you sure you want to delete this folder?"
                : "Are you sure you want to delete this folder and all its subfolders?"}
            </Typography>
          </Grid>

          <Grid item xs={12} align="right">
            <Button sx={{ color: "red" }} onClick={() => onDismiss()}>
              Cancel
            </Button>
            <Button sx={{ color: "green" }} onClick={onDeleteFolder}>
              Confirm
            </Button>
          </Grid>
        </Grid>
      </Box>
    </Modal>
  );
};

export default DeleteFolderModal;
